import { useKeyboard, UseKeyboardLevel, useOnOutsideClick } from "@hubrise/react-components"
import * as React from "react"

import { StyledMenu, Dropdown, DropdownItem } from "./Styles"

type Action = {
  label: string
  onClick: () => void
  disabled?: boolean
}

interface DropdownMenuProps {
  link: ({ onClick }: { onClick: () => void }) => JSX.Element
  actions: Array<Action>
  refForScrollDetection?: React.RefObject<HTMLDivElement>
  className?: string
}

const DropdownMenu = ({ link, actions, refForScrollDetection, className }: DropdownMenuProps): JSX.Element => {
  const $ref = React.useRef<HTMLDivElement>(null)

  const [menuOpen, setMenuOpen] = React.useState(false)
  const closeMenu = () => setMenuOpen(false)

  React.useEffect(() => {
    setTimeout(() => {
      if (refForScrollDetection?.current != null) {
        refForScrollDetection.current.addEventListener("scroll", closeMenu)
      }
    }, 0)
  }, [refForScrollDetection])

  useOnOutsideClick([$ref], menuOpen, closeMenu)
  useKeyboard(UseKeyboardLevel.Modal, { code: "Escape" }, closeMenu, {
    isListening: menuOpen,
    description: "closeMenu",
  })

  return (
    <StyledMenu ref={$ref} className={className} onMouseDown={(e) => e.stopPropagation()}>
      {link({ onClick: () => setMenuOpen(!menuOpen) })}

      {menuOpen && (
        <Dropdown>
          {actions.map((action, i) => (
            <DropdownItem
              key={i}
              onClick={(event) => {
                if (action.disabled !== true) {
                  event.stopPropagation()
                  closeMenu()
                  action.onClick()
                }
              }}
              disabled={action.disabled === true}
            >
              {action.label}
            </DropdownItem>
          ))}
        </Dropdown>
      )}
    </StyledMenu>
  )
}

export default DropdownMenu
